import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { getTypeLabel } from "@/lib/labels";

interface MediaCardProps {
  item: MediaItem;
  showActors?: boolean;
}

export default function MediaCard({ item, showActors = false }: MediaCardProps) {
  const typeLabel = getTypeLabel(item.type);
  const altText = `${item.title} ${item.genre}${typeLabel}封面`;

  return (
    <Link to={`/detail/${item.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.cover}
          alt={altText}
          title={`${item.title} - ${item.genre}${typeLabel}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur">
          {typeLabel}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        {showActors ? (
          <p className="mt-1 truncate text-xs text-foreground-500">
            主演：{item.actors.slice(0, 3).join(" / ")}
          </p>
        ) : null}
        <p className="mt-1 truncate text-xs text-foreground-500">
          {item.year} · {item.region} · {item.genre}
        </p>
      </div>
    </Link>
  );
}